import type { ResourceListItemFront } from '../../../domain/domain/models/resources.model';
import type { EditResourceFormValues } from '../resources-list/ResourcesList.model';

export function updateResourceItem(
  updated: EditResourceFormValues,
  current: ResourceListItemFront,
): ResourceListItemFront {
  return {
    ...current,
    name: updated.name,
    description: updated.description,
  };
}
